module.exports = __webpack_public_path__ + "static/media/IMG-6.0ded57df.jpg";